<template>
  <div id="layout_header" class="header">
    <div class="header_wrapper">
      <h1>
        <router-link :to="{ name: 'root' }">
          <img :src="require('images/ucenter/dashboard/junanex_logo.png')" />
        </router-link>
      </h1>
      <el-menu
        :default-active="activeMenu"
        @select="navSelect"
        class="header_nav"
        mode="horizontal"
        background-color="#3675b6"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="root">首页</el-menu-item>
        <el-menu-item index="inbounds">我的货物</el-menu-item>
        <el-menu-item index="outbounds">我的订单</el-menu-item>
        <el-menu-item index="outbound_groups">我的拼团</el-menu-item>
        <el-menu-item index="invoices">我的账户</el-menu-item>
        <!-- <el-menu-item index="articles">系统公告</el-menu-item> -->
        <el-submenu
          index="guides_main"
          popper-class="layout_header_guides_submenu"
        >
          <template slot="title">新手指南</template>
          <el-menu-item index="process_flow">操作流程</el-menu-item>
          <el-menu-item index="guides">新手指南</el-menu-item>
          <el-menu-item index="articles">系统公告</el-menu-item>
        </el-submenu>
        <el-menu-item index="price_calculator">资费标准</el-menu-item>
        <!-- <el-menu-item index="portal"><a href="/" target="_blank">公众网站</a></el-menu-item> -->
      </el-menu>
    </div>
  </div>
</template>

<style lang="scss">
.header {
  height: 60px;
  background: #3675b6;
  margin-bottom: 35px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  border-top: 1px solid #104f90;
}
.header_wrapper {
  height: 60px;
  width: 1200px;
  margin: 0 auto;
}
.header h1 {
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  float: left;
  margin: 0;
  padding: 0;
}
.header h1 a {
  color: #fff;
  text-decoration: none;
  display: inline-block;
  width: 125px;
  height: 35px;
  padding: 11px 2px 14px 2px;
}
.header h1 img {
  width: 125px;
  height: 35px;
}
.header .header_nav {
  float: right;
}
.header .header_nav a {
  text-decoration: none;
}
#layout_header .el-menu-item.is-active {
  border-bottom: 3px solid #f6ab00;
}
#layout_header .el-submenu.is-active {
  .el-submenu__title {
    border-bottom: 3px solid #f6ab00;
  }
}
</style>

<script>
export default {
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.headerNavType) {
        return meta.headerNavType;
      }
      return null;
    },
  },
  methods: {
    navSelect(key, keyPath) {
      if (
        key == "root" ||
        key == "inbounds" ||
        key == "outbounds" ||
        key == "outbound_groups" ||
        key == "invoices" ||
        key == "articles" ||
        key == "price_calculator" ||
        key == "guides" ||
        key == "process_flow"
      ) {
        this.$router.push({ name: key });
      }
    },
  },
};
</script>
